export function emptyFilter(input, placeholder: string = '-'): string {

    return input === null || input === undefined ? placeholder : input;
}